import { Component, OnInit } from '@angular/core';
import { HeaderBarComponent } from '../header-bar/header-bar.component';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { Http } from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageBag, ValidationMessagesService } from 'ng2-custom-validation';
import { Router } from '@angular/router';
import { FoodServiceService } from 'app/food-service.service';
import { LocalStorage, SessionStorage } from "angular2-localstorage";
import * as $ from 'jquery';
import { PushNotificationsService } from 'angular2-notifications'; 
@Component({
  selector: 'app-footer-bar',
  templateUrl: './footer-bar.component.html',
  styleUrls: ['./footer-bar.component.css']
})
export class FooterBarComponent implements OnInit {
	settings={};
  loginForm: FormGroup;
  registerForm : FormGroup;
  new:Object={};
  user:Object={};
  tastes:any[]=[];
  categories:any[]=[];
  foods:any[]=[];
  errorMessage:any[]=[];
  catogoryidforfood=''; 
  errors: MessageBag = new MessageBag();
  logged_in_user=''; 
  UserLoggedIn= JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
  constructor(private SettingService: HeaderBarComponent,private CommonService: WebApiObservableService,private fb: FormBuilder,private validationMessagesService: ValidationMessagesService, private router: Router, private _Food: FoodServiceService,private _pushNotifications: PushNotificationsService) { 
       _pushNotifications.requestPermission();
  }

  ngOnInit() {
  	this.SettingService.callsettings((data) => {
        this.settings = data;
    });
       this.loginForm = this.fb.group({
            'mobile': ['', [
                Validators.required,
                Validators.minLength(10),
                Validators.maxLength(10)
            ]],
            'password': ['', [
                Validators.required,
                Validators.minLength(6)               
            ]]
        });
        this.validationMessagesService
            .seeForErrors(this.loginForm)
            .subscribe((errors: MessageBag) => {
                this.errors = errors;
            });

    this.registerForm = this.fb.group({
            'name': ['', [
                Validators.required,
                Validators.minLength(2)
                
            ]],
            'username': ['', [
                Validators.required,
                Validators.minLength(6)
            ]],
            'email': ['', [
                Validators.required,
                Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)               
            ]],
            'mobile': ['', [
                Validators.required,
                Validators.minLength(10),
                Validators.maxLength(10)
            ]],
            'password': ['', [
                Validators.required,
                Validators.minLength(6)               
            ]]
        });
        this.validationMessagesService
            .seeForErrors(this.registerForm)
            .subscribe((errors: MessageBag) => {
                this.errors = errors;
            });

    /*Calling Api for taste of locations */
    this.CommonService
            .getService('/tasteoflocations')
            .subscribe(
                result => this.tastes = result,
                error => this.errorMessage = <any>error
            );



    /*Calling Api for Categories */
    this.CommonService
            .getServiceForSearch('/categories','status','10')
            .subscribe(
                result => this.categories = result.items,
                error => this.errorMessage = <any>error
            );
  }OnSubmit(myModal){ 

    this.CommonService
            .createService('/users', this.new)
            .subscribe(
                result => {
                  this.logged_in_user=result;                 
                  localStorage.setItem('AUTH_TOKEN',result.auth_key);
                  localStorage.setItem('LOGGED_IN_USER',JSON.stringify(result));
                  myModal.close();                  
                  this.UserLoggedIn=JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
                  let options = {
                      body: "Registeration Successful",
                      icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                     
                  }
                  let notify = this._pushNotifications.create('Success', options).subscribe( 
                   );
                  },
                error => this.errorMessage = <any>error
            );
  }
  loginError='';  
  OnLogin(myModal){   

     this.CommonService
            .createService('/users/login', this.user)
            .subscribe(
                result =>{
                  this.logged_in_user=result.user;               
                  localStorage.setItem('AUTH_TOKEN',result.auth_token);
                  localStorage.setItem('LOGGED_IN_USER',JSON.stringify(result.user));
                  myModal.close();
                  
                  this.UserLoggedIn=JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
                  let options = {
                      body: "Login Successful",
                      icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                   
                  }
                  let notify = this._pushNotifications.create('Success', options).subscribe( 
                   );
                  },
                error => this.loginError = <any>error
            );
  }

  Onrefresh(){
    this.loginForm.reset();
    this.registerForm.reset();
  }
 LogOut(){
    localStorage.clear();
    this.UserLoggedIn= null;
    this.refresh();
  }

  SubmitRegister(myModal){ 

    this.CommonService
            .createService('/users', this.new)
            .subscribe(
                result => {
                  this.logged_in_user=result;                 
                  localStorage.setItem('AUTH_TOKEN',result.auth_key);
                  localStorage.setItem('LOGGED_IN_USER',JSON.stringify(result));
                  myModal.close();                  
                  this.UserLoggedIn=JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
                  let options = {
                      body: "Registeration Successful",
                      icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                     
                  }
                  let notify = this._pushNotifications.create('Success', options).subscribe( 
                   );
                  },
                error => this.errorMessage = <any>error
            );
  }
  Errorlogin='';  
  SubmitLogin(myModal){   

     this.CommonService
            .createService('/users/login', this.user)
            .subscribe(
                result =>{
                  this.logged_in_user=result.user;               
                  localStorage.setItem('AUTH_TOKEN',result.auth_token);
                  localStorage.setItem('LOGGED_IN_USER',JSON.stringify(result.user));
                  myModal.close();
                  
                  this.UserLoggedIn=JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
                  let options = {
                      body: "Login Successful",
                      icon:'http://test.eatasiafood.com/uploads/logo/logo.png',                   
                  }
                  let notify = this._pushNotifications.create('Success', options).subscribe( 
                   );
                  },
                error => this.Errorlogin = <any>error
            );
  }

  refresh(){
    this.loginForm.reset();
    this.registerForm.reset();
  }
 OnLogOut(){
    localStorage.clear();
    this.UserLoggedIn= null;
    this.refresh();
  }

}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/footer-bar/footer-bar.component.ts